export default __webpack_public_path__ + "static/media/0xecf8f2fa183b1c4d2a269bf98a54fce86c812d3e.b156db27.png";